<div class="panel" [class.p-4]="!appSettings.isMobile()" [class.p-3]="appSettings.isMobile()">
    <!-- Cabecera adaptativa -->
    <div class="d-flex justify-content-between align-items-start mb-4" [class.flex-column]="appSettings.isMobile()" [class.gap-2]="appSettings.isMobile()">
        <div>
            <h4 class="mb-1 fw-bold">{{ titleLabel() }}</h4>
            <p class="text-muted small mb-0">{{ subtitleLabel() }}</p>
        </div>
        <div [class.text-end]="!appSettings.isMobile()">
            <h3 class="text-primary mb-0 fw-bold">
                {{ (request()?.payment?.amount ?? request()?.amount ?? 0) | currency:'CLP':'$':'1.0-0' }}
            </h3>
            <span class="badge bg-light text-dark border mt-1">{{ movementTypeBadge() }}</span>
        </div>
    </div>

    <!-- Cuerpo: datos + comprobante vía request_uuid -->
    <div class="row g-4 mb-4" [class.align-items-center]="!appSettings.isMobile()">
        <div [class.col-md-8]="!appSettings.isMobile()" [class.col-12]="appSettings.isMobile()">
            <table class="table table-sm table-borderless mb-0">
                <tbody>
                    <tr>
                        <td class="text-muted small text-uppercase pb-2" style="width: 140px;">Fecha:</td>
                        <td class="fw-bold pb-2">{{ (request()?.payment?.paymentDate ?? request()?.createdAt) | date:'dd/MM/yyyy' }}</td>
                    </tr>
                    <tr>
                        <td class="text-muted small text-uppercase pb-2">Periodo:</td>
                        <td class="fw-bold pb-2">{{ request()?.payment?.year ?? request()?.year }}-{{ request()?.payment?.period ?? request()?.period }}</td>
                    </tr>
                    <tr>
                        <td class="text-muted small text-uppercase pb-2">Entidad:</td>
                        <td class="fw-bold pb-2 text-truncate d-inline-block" style="max-width: 280px;">
                            {{ getEntityName(request()?.entityCode) }}
                        </td>
                    </tr>
                    @if(detailsText()) {
                        <tr>
                            <td class="text-muted small text-uppercase pb-2">Glosa / Detalle:</td>
                            <td class="fw-bold pb-2 text-dark">{{ detailsText() }}</td>
                        </tr>
                    }
                    <tr>
                        <td class="text-muted small text-uppercase">ID Solicitud:</td>
                        <td class="font-monospace fw-bold small text-muted">{{ request()?.uuid }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div [class.col-md-4]="!appSettings.isMobile()" [class.col-12]="appSettings.isMobile()">
            @if (appSettings.isMobile()) {
                @if (docUrl()) {
                    <button type="button" class="btn btn-outline-primary btn-sm w-100"
                        (click)="openViewer()">
                        <i class="fas fa-eye me-1"></i>Ver comprobante
                    </button>
                } @else {
                    <div class="text-muted small d-flex align-items-center gap-2">
                        <i class="fas fa-file-invoice-dollar text-secondary"></i>
                        <span>Sin comprobante adjunto</span>
                    </div>
                }
            } @else if (docUrl()) {
                <div class="payment-thumbnail-container mx-auto" (click)="openViewer()" role="button" tabindex="0"
                    (keydown.enter)="openViewer()">
                    <div class="thumbnail-overlay">
                        <i class="fas fa-eye text-white"></i>
                    </div>
                    <img [src]="docUrl() | safeUrl"
                         class="img-fluid rounded shadow-sm border" alt="Comprobante / Respaldo">
                </div>
                <div class="text-center mt-1">
                    <small class="text-muted" style="font-size: 0.65rem;">VER RESPALDO ADJUNTO</small>
                </div>
            } @else {
                <div class="border rounded p-3 text-center bg-light small">
                    <i class="fas fa-file-invoice-dollar fa-2x mb-2 d-block text-secondary"></i>
                    <span class="text-muted d-block">Sin comprobante adjunto</span>
                </div>
            }
        </div>
    </div>

    <!-- Historial BPM de aprobación -->
    <div class="mb-4">
        <app-flow-steps
            [request]="request()"
            (viewDocument)="openViewer()">
        </app-flow-steps>
    </div>

    @if(isObserved() && observationReason()) {
        <div class="alert alert-warning d-flex align-items-start mb-3 py-2 px-3">
            <i class="fas fa-exclamation-triangle me-2 mt-1"></i>
            <div>
                <strong>Observación:</strong> {{ observationReason() }}
            </div>
        </div>
    }

    <!-- Botones de acción gobernados por BPM (solo desktop) -->
    @if (!appSettings.isMobile()) {
        @if(canResubmit()) {
            <div class="pt-4 d-flex gap-3 justify-content-center border-top">
                <button class="btn btn-warning btn-lg px-5" (click)="resubmitObservation()" [disabled]="isProcessingApproval()">
                    @if(isProcessingApproval()) {
                        <i class="fas fa-spinner fa-spin me-2"></i> Procesando...
                    } @else {
                        <i class="fas fa-upload me-2"></i> Adjuntar y reenviar
                    }
                </button>
            </div>
        } @else if(canApprove() || canObserve()) {
            <div class="pt-4 d-flex gap-3 justify-content-center border-top flex-wrap">
                @if(canApprove()) {
                    <button class="btn btn-success btn-lg px-5" (click)="approve()" [disabled]="isProcessingApproval()">
                        @if(isProcessingApproval()) {
                            <i class="fas fa-spinner fa-spin me-2"></i> Procesando...
                        } @else {
                            <i class="fas fa-check-circle me-2"></i> {{ approveBtnLabel() }}
                        }
                    </button>
                }
                @if(canObserve()) {
                    <button class="btn btn-outline-warning btn-lg px-4" (click)="observe()" [disabled]="isProcessingApproval()">
                        <i class="fas fa-exclamation-triangle me-2"></i> Observar
                    </button>
                }
                @if(canApprove()) {
                    <button class="btn btn-outline-danger btn-lg px-4" (click)="reject()" [disabled]="isProcessingApproval()">
                        <i class="fas fa-times me-2"></i> Rechazar
                    </button>
                }
            </div>
        } @else {
            <div class="pt-3 border-top text-center">
                <div class="alert alert-light border mb-0 d-inline-block px-4 py-2 small text-muted">
                    <i class="fas fa-info-circle me-2 text-primary"></i>
                    Estado actual del trámite: <strong class="text-dark">{{ statusLabel() }}</strong>
                    @if(isClosed()) {
                        <span class="badge bg-secondary ms-2">Cerrado</span>
                    }
                </div>
            </div>
        }
    } @else if (!showBpmActions()) {
        <div class="pt-3 border-top text-center">
            <div class="alert alert-light border mb-0 d-inline-block px-3 py-2 small text-muted">
                <i class="fas fa-info-circle me-2 text-primary"></i>
                Estado: <strong class="text-dark">{{ statusLabel() }}</strong>
                @if(isClosed()) {
                    <span class="badge bg-secondary ms-2">Cerrado</span>
                }
            </div>
        </div>
    }
</div>

<!-- Acciones BPM en footer móvil -->
<app-mobile-footer [visible]="showMobileFooter()">
    @if (canResubmit()) {
        <button type="button" class="btn btn-warning btn-sm w-100"
            (click)="resubmitObservation()" [disabled]="isProcessingApproval()">
            @if (isProcessingApproval()) {
                <span class="spinner-border spinner-border-sm me-1"></span>
            } @else {
                <i class="fas fa-upload me-1"></i>
            }
            Adjuntar y reenviar
        </button>
    } @else {
        @if (canApprove()) {
            <button type="button" class="btn btn-outline-danger btn-sm"
                (click)="reject()" [disabled]="isProcessingApproval()">
                <i class="fas fa-times me-1"></i>Rechazar
            </button>
        }
        @if (canObserve()) {
            <button type="button" class="btn btn-outline-warning btn-sm"
                (click)="observe()" [disabled]="isProcessingApproval()">
                <i class="fas fa-exclamation-triangle me-1"></i>Observar
            </button>
        }
        @if (canApprove()) {
            <button type="button" class="btn btn-success btn-sm flex-grow-1"
                (click)="approve()" [disabled]="isProcessingApproval()">
                @if (isProcessingApproval()) {
                    <span class="spinner-border spinner-border-sm me-1"></span>
                } @else {
                    <i class="fas fa-check-circle me-1"></i>
                }
                {{ approveBtnLabel() }}
            </button>
        }
    }
</app-mobile-footer>

<!-- Modal / pantalla de Aprobación / Subida de Documento BPM -->
<app-step-approval-modal
    [request]="request()"
    [isProcessing]="isProcessingApproval()"
    (confirmed)="onApprovalConfirmed($event)"
    (cancelled)="onApprovalCancelled()">
</app-step-approval-modal>

<!-- Visor del comprobante / respaldo -->
@if(isViewerOpen()) {
    <app-viewer
        [items]="viewerItems()"
        [activeId]="activeDocId()"
        (close)="isViewerOpen.set(false)"
        (onSelect)="activeDocId.set($event)">
    </app-viewer>
}
